/* eslint-disable @typescript-eslint/no-redeclare */

export const StateFilter = {
  ALL: "",
  // ARCHIVED: "ARCHIVED",
  CANCELLED: "CANCELLED",
} as const;
export type StateFilter = keyof typeof StateFilter;
